<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <!-- <div v-if="successMessage" class="alert alert-success">
                    {{ successMessage }}
                </div> -->
        <div class="card shadow-lg">
          <div class="card-header bg-primary text-white">New Note</div>
          <div class="card-body">
            <form action="" method="post" @submit.prevent="store">
              <div class="form-group">
                <label for="title">Title</label>
                <input
                  type="text"
                  v-model="form.title"
                  id="title"
                  class="form-control"
                placeholder="Masukkan Title"/>
                <div v-if="theErrors.title" class="mt-2 text-danger">
                  {{ theErrors.title[0] }}
                </div>
              </div>
              <div class="form-group">
                <label for="subject">Subject</label>
                <select
                  v-model="form.subject"
                  id="subject"
                  class="form-control"
                >
                <option value="" disabled selected>--Pilih Subject--</option>
                  <option
                    v-for="subject in subjects"
                    :key="subject.id"
                    :value="subject.id"
                  placholder="Masukkan Title">
                    {{ subject.name }}
                  </option></select
                >
                <div v-if="theErrors.subject" class="mt-2 text-danger">
                  {{ theErrors.subject[0] }}
                </div>
              </div>
              <div class="form-group">
                <label for="description">Description</label>
                <textarea
                  v-model="form.description"
                  rows="5"
                  id="description"
                  class="form-control"
                placeholder="Masukkan Deskripsi"></textarea>
                <div v-if="theErrors.description" class="mt-2 text-danger">
                  {{ theErrors.description[0] }}
                </div>
              </div>
              <button
                type="submit"
                class="btn btn-primary d-flex align-items-center"
              >
                Save
                <template v-if="loading">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    style="margin: auto; background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%; display: block; shape-rendering: auto;"
                    width="30px"
                    height="20px"
                    viewBox="2 0 100 100"
                    preserveAspectRatio="xMidYMid"
                  >
                    <rect x="17.5" y="30" width="15" height="40" fill="#1d3f72">
                      <animate
                        attributeName="y"
                        repeatCount="indefinite"
                        dur="1s"
                        calcMode="spline"
                        keyTimes="0;0.5;1"
                        values="18;30;30"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                        begin="-0.2s"
                      ></animate>
                      <animate
                        attributeName="height"
                        repeatCount="indefinite"
                        dur="1s"
                        calcMode="spline"
                        keyTimes="0;0.5;1"
                        values="64;40;40"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                        begin="-0.2s"
                      ></animate>
                    </rect>
                    <rect x="42.5" y="30" width="15" height="40" fill="#5699d2">
                      <animate
                        attributeName="y"
                        repeatCount="indefinite"
                        dur="1s"
                        calcMode="spline"
                        keyTimes="0;0.5;1"
                        values="20.999999999999996;30;30"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                        begin="-0.1s"
                      ></animate>
                      <animate
                        attributeName="height"
                        repeatCount="indefinite"
                        dur="1s"
                        calcMode="spline"
                        keyTimes="0;0.5;1"
                        values="58.00000000000001;40;40"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                        begin="-0.1s"
                      ></animate>
                    </rect>
                    <rect x="67.5" y="30" width="15" height="40" fill="#d8ebf9">
                      <animate
                        attributeName="y"
                        repeatCount="indefinite"
                        dur="1s"
                        calcMode="spline"
                        keyTimes="0;0.5;1"
                        values="20.999999999999996;30;30"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                      ></animate>
                      <animate
                        attributeName="height"
                        repeatCount="indefinite"
                        dur="1s"
                        calcMode="spline"
                        keyTimes="0;0.5;1"
                        values="58.00000000000001;40;40"
                        keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
                      ></animate>
                    </rect>
                    <!-- [ldio] generated by https://loading.io/ -->
                  </svg>
                </template>
              </button>
            </form>
          </div>
        </div>
      </div>
      <img src="@/assets/add.svg" class="mx-auto mt-2" />
      <!-- <img src="@/assets/notes.svg" class="rounded mx-auto d-block" /> -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      form: {
        title: "",
        description: "",
        subject: "",
      },

      // successMessage: "",
      loading: false,
      subjects: [],
      theErrors: [],
    };
  },

  mounted() {
    this.getSubjects();
  },

  methods: {
    async getSubjects() {
      let response = await axios.get("/api/subjects");
      // console.log(response.data);
      if (response.status === 200) {
        this.subjects = response.data;
      }
    },

    async store() {
      this.loading = true;
      try {
        let response = await axios.post(
          "/api/notes/create-new-note",
          this.form
        );
        if (response.status == 200) {
          this.form.title = "";
          this.form.subject = "";
          this.form.description = "";
          this.theErrors = [];
          this.loading = false;
          // this.successMessage = response.data.message;
          this.$toasted.show(response.data.message, {
            type: "success",
            duration: 2000,
          });
        }
      } catch (e) {
        this.loading = false;
        this.$toasted.show("Something went wrong.", {
          type: "error",
          duration: 2000,
        });
        this.theErrors = e.response.data.errors;
      }
    },
  },
};
</script>

<style scoped>

 /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {img {display:none;}}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {img {display:none;}}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {img {display:block;
width: 40%;}}
</style>